/**
 * @generated SignedSource<<f3073c3fcd11ed13d9af6ecd1b058ae7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TopicsAdminTopicListItem_storeTopic$data = {
  readonly id: string;
  readonly isPrivate: boolean | null;
  readonly name: string;
  readonly teams: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"AHTeamIconCircle">;
  }> | null;
  readonly " $fragmentType": "TopicsAdminTopicListItem_storeTopic";
};
export type TopicsAdminTopicListItem_storeTopic$key = {
  readonly " $data"?: TopicsAdminTopicListItem_storeTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopicsAdminTopicListItem_storeTopic">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopicsAdminTopicListItem_storeTopic",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AHTeamIconCircle"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoreTopic",
  "abstractKey": null
};
})();

(node as any).hash = "3887d7184a02411df0338d51e113bd93";

export default node;
